var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a',{attrs:{"href":"#","name":"HeadSort"},on:{"click":function($event){$event.preventDefault();return _vm.handleClick.apply(null, arguments)}}},[_c('i',{class:_vm.cls})])
}
var staticRenderFns = []

export { render, staticRenderFns }